import { inject, computed, unref } from "vue";

const createTranslation = (key, defaultValue) => {
  const data = new FormData();
  data.append("key", key);
  data.append("value", defaultValue);

  fetch("/api/admin/translations", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "X-CSRF-Token": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    },
    body: data,
  });
};

export function useTranslation() {
  const translations = inject("translations", {});

  const _t = (key, defaultValue) => {
    return computed(() => {
      const map = unref(translations);
      const resolved = map && typeof map === "object" ? map : {};

      if (!resolved[key]) {
        createTranslation(key, defaultValue);
      }

      return resolved[key] || defaultValue;
    });
  };

  return { _t };
}
